import React, { useCallback, useEffect, useRef, useState, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Input, Empty } from "antd";
import { default as api } from "@/components/Joyspace/api";
import { IconCircleClose, IconSearch } from "@/components/icon";
import "./index.less";
import GroupSearchList from "./GroupSearchList";
import events from "@/components/Joyspace/context/events";
const { Search } = Input;

interface IPpros {
  type: string;
  gid: string;
}
let start = 0;
let timer: any;
const GroupSearch = (props: IPpros) => {
  const { gid } = props;
  const [keyWord, setKeyWord] = useState("");
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const searchRef = useRef<any>();
  const { t } = useTranslation("chat");
  const [isChange, setIsChange] = useState(false);
  const [currentFolderIds, setCurrentFolderIds] = useState<string[]>([]);
  const [preFolderId, setPreFolderId] = useState("");

  useEffect(() => {
    setCurrentFolderIds([gid]);
    setPreFolderId(gid);
  }, [gid]);

  const onSearch = useCallback(
    (value: any, _start = 0) => {
      const trimValue = value.trim();
      api.pages
        .zhuanbanSearch({
          search: trimValue,
          length: 20,
          start: _start,
          t: "page",
          folderId: gid, // 组空间id
          folderIds: currentFolderIds, // 指定的文件夹
          modes: ["PageContent", "Folder"]
        })
        .then((result) => {
          _start > 0
            ? setList((data: any) => {
                return data.concat(result?.data);
              })
            : setList(result?.data || []);
          setTotal(result.total || 0);
          setLoading(false);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    [currentFolderIds, gid]
  );

  const changeFolderIds = useCallback(
    (folderId: string) => {
      setCurrentFolderIds((prevState) => {
        setPreFolderId(prevState[0]);
        return [folderId];
      });
    },
    [setCurrentFolderIds, setPreFolderId]
  );

  useEffect(() => {
    events.on("groupspace.setSearchFolderId", changeFolderIds);
    events.on("groupspace.searchList.onClose", onClose);
    return () => {
      events.off("groupspace.onClose", changeFolderIds);
      events.off("groupspace.searchList.onClose", onClose);
    };
  }, [changeFolderIds]);

  // 加载更多
  const loadMore = useCallback(() => {
    if (list.length >= total) {
      return;
    }
    start += 20;
    onSearch(keyWord, start);
  }, [keyWord, total, list, onSearch]);

  const onClose = useCallback(() => {
    setVisible(false);
  }, []);

  // 点击空白处关闭搜索框
  useEffect(() => {
    // 注意这里是获取classname search下的第一个子节点，如果需改了DOM结构那个这个可能会失效
    const input: any = document.getElementsByClassName("search")[0].firstElementChild;
    input.onclick = function (event: any) {
      event.stopImmediatePropagation();
    };
    document.addEventListener("click", onClose);
    return () => {
      document.removeEventListener("click", onClose);
    };
  }, [onClose]);

  const renderListDOM = useMemo(() => {
    return (
      <GroupSearchList
        loading={loading}
        list={list}
        loadMore={loadMore}
        total={total}
        t={t}
        onClose={onClose}
      />
    );
  }, [loading, list, loadMore, total, t]);

  const init = useCallback(() => {
    start = 0;
    setTotal(0);
  }, []);

  const handleSearch = useCallback(
    (value: any) => {
      setLoading(true);
      setVisible(value.length > 0);
      setKeyWord(value);
      clearTimeout(timer);
      timer = setTimeout(() => {
        onSearch(value);
      }, 400);
    },
    [onSearch]
  );

  // 解决中文拼音未输入完就进行搜索的问题
  useEffect(() => {
    if (!keyWord) {
      setVisible(false);
    }
    if (!isChange && keyWord) {
      handleSearch(keyWord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWord, isChange]);

  return (
    <Dropdown
      visible={visible}
      placement="bottomCenter"
      overlayClassName="groupspace-search-dropdown"
      overlay={renderListDOM}
    >
      <div className="search-container">
        <span
          className="groupspace-search-icon"
          onClick={(event: any) => {
            event.nativeEvent.stopImmediatePropagation();
            handleSearch(searchRef.current?.props.value);
          }}
        >
          {IconSearch}
        </span>
        <Search
          ref={searchRef}
          className="search app-region-none"
          value={keyWord}
          placeholder={
            currentFolderIds[0] === gid ? t("search.searchGroupText") : t("search.searchFolderText")
          }
          onFocus={() => {
            if (keyWord && preFolderId === currentFolderIds[0]) {
              setVisible(true);
            }
            if (keyWord && preFolderId !== currentFolderIds[0]) {
              handleSearch(keyWord);
              setPreFolderId(currentFolderIds[0]);
            }
          }}
          onChange={(event: any) => {
            init();
            setKeyWord(event.target.value);
          }}
          onCompositionStart={() => {
            setIsChange(true);
          }}
          onCompositionEnd={(event: any) => {
            setKeyWord(event.target.value);
            setIsChange(false);
          }}
        />
        {keyWord && !isChange && (
          <span
            className="close-circle-icon app-region-none"
            onClick={() => {
              searchRef.current && searchRef.current.focus();
              setKeyWord("");
              init();
              onClose();
            }}
          >
            {IconCircleClose}
          </span>
        )}
      </div>
    </Dropdown>
  );
};

export default GroupSearch;
